export default __webpack_public_path__ + "static/media/certik.78e8f046.png";